'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './upload-archive.routes';

export class UploadArchiveComponent {

  constructor(StorageService, $timeout, $uibModal, Config) {
    'ngInject';

    this.roles = Config.getPlatformConfig().getPermissionRoles();

    this.$uibModal = $uibModal;
    this.dataReady = false;

    this.asTable = true;

    this.currentPage = 1;
    this.itemsPerPage = Config.getPaginationWithDefault("uploadArchive", 18);

    this.data = [];
    this.month = ["Jan","Feb","Mar","Apr","Mai","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

    this.StorageService = StorageService;
    this.$timeout = $timeout;
    this.baseUrl = Config.getPlatformConfig().getBaseUrl();

    this.currentYear = moment().format("YYYY");
    this.currentMonth = moment().format("M");

    this.refreshData();
  }

  refreshData() {
    this.dataByMonth = {
      1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [], 8: [], 9: [], 10: [], 11: [], 12: [], older: []
    };

    this.StorageService.query(
      data => {
        data.forEach(item => {
          var month = moment(item.creationDate).format("M");
          var year = moment(item.creationDate).format("YYYY");

          if (year !== this.currentYear) {
            this.dataByMonth["older"].push(item);
          } else {
            this.dataByMonth[month].push(item);
          }
        });

        var that = this;
        this.$timeout(function(){
          that.dataReady = true;
          jQuery("ul.nav.nav-tabs li:nth-child("+that.currentMonth+") a").click();
        }, 500);
      },
      err => {
        console.log('Could not retrieve data.');
      });
  }

  setAsTable(val) {
    this.asTable = val;
  }

  isActive(month) {
    return month == this.currentMonth;
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  isHtmlMime(mime) {
    return mime == 'text/html';
  }

  openImageEditor(asset) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'imageEditor',
      resolve: {
        config: function() {
          return {
            storageId: asset._id
          }
        }
      }
    });

    modalInstance.result.then(
      function () {},
      function () { /* cancel */ }
    );

  }

  openAssetPermissionModal(asset) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetPermission',
      resolve: {
        config: function() {
          return {
            asset: angular.copy(asset)
          }
        }
      }
    });

    modalInstance.result.then(
      function () {
        that.refreshData();
      },
      function () { /* cancel */ }
    );

  }

  openAssetUploadModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(
      function () {
        that.refreshData();
      },
      function () { /* cancel */ }
    );

  }

  setFilter(month) {
    if (!this.dataReady)
      return;

    this.currentPage = 1;
    this.data = this.dataByMonth[month];
    this.currentMonth = month;
  }

  getCount(month) {
    return this.dataByMonth[month].length;
  }

  getUserShort(user) {
    return (user) ? user.firstName + " " + user.lastName[0] + "." : "unknown";
  }

  copyToClipboard(asset) {
    let publicPath = asset.isPublic ? "public/" : "";
    let path = this.baseUrl + "/api/storage/" + publicPath + asset._id;
    window.prompt("Path to Resource:", path);
  }

}

export default angular.module('conduuApp.uploadArchive', [uiRouter])
  .config(routes)
  .component('uploadArchive', {
    template: require('./upload-archive.html'),
    controller: UploadArchiveComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/upload/archive/upload-archive.component.js